var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      ref: "rangeDateTime",
      staticClass: "date-time-range",
      attrs: { prop: "rangeDateTime", label: _vm.label, rules: _vm.rules }
    },
    [
      _c(
        "el-form",
        { attrs: { inline: true, model: _vm.form } },
        [
          _c(
            "el-form-item",
            {
              ref: "rangeDateTimeInner",
              attrs: { prop: "rangeDateTimeInner", rules: _vm.rules }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetimerange",
                  format: "yyyy/MM/dd HH:mm",
                  "value-format": "yyyy/MM/dd HH:mm",
                  "range-separator": _vm.rangeSeparator,
                  "start-placeholder": _vm.startPlaceholder,
                  "end-placeholder": _vm.endPlaceholder,
                  disabled: _vm.disabled,
                  autofocus: _vm.autofocus
                },
                model: {
                  value: _vm.rangeDateTime,
                  callback: function($$v) {
                    _vm.rangeDateTime = $$v
                  },
                  expression: "rangeDateTime"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }